// Form pieces for the alert destinations surface, under the names this
// surface's files import. Each is the kit's (ui/Field.jsx, ui/Notice.jsx,
// ui/styles.js, ui/Button.jsx); what this layer adds is the required marker.

import Field from "../ui/Field.jsx";
import { SaveStatus } from "../ui/Notice.jsx";
import { buttonClass } from "../ui/Button.jsx";
import { FIELD } from "../ui/styles.js";

// A field the caller marks aria-invalid turns its edge to the error colour.
export const inputCls = `${FIELD} aria-[invalid=true]:border-[color:var(--danger)]`;

export const primaryBtnCls = buttonClass("primary");

export const secondaryBtnCls = buttonClass("secondary");

export function FormField({ label, hint = null, error = null, required = false, as = "label", children }) {
    return (
        <Field
            as={as}
            hint={hint}
            error={error}
            label={
                <>
                    {label}
                    {/* On the field itself. It used to be a line at the foot of
                        the dialog naming the first outstanding field, which read
                        as an error about whichever field you were in. */}
                    {required ? (
                        <span className="font-normal text-[color:var(--muted-soft)]" aria-hidden="true">
                            {" *"}
                        </span>
                    ) : null}
                </>
            }
        >
            {children}
        </Field>
    );
}

// No "saved" state: the dialog that owns this closes on success, so a
// confirmation here could never be read. It is shown on the panel instead.
//
// It does not say WHY the submit is disabled: that line named the first
// outstanding field, so typing a name surfaced "Enter the Slack webhook URL"
// underneath. Required fields are marked on the fields; per-field validation
// still speaks up once there is something to judge.
export function StatusLine({ status, error }) {
    return <SaveStatus status={status === "saving" ? "saving" : null} error={error} />;
}
